<section>
  <a href="/legal/ts-and-cs{{legal}}">Terms and Conditions</a>
  <a href="/legal/privacy-policy{{legal}}">Privacy Policy</a>
  <!-- <a href="/legal/cookies-policy">Cookies Policy</a> -->
</section>
